import type { OneTimeWalletViewModel, WalletViewModel } from '@olv/ui-shared/models/wallet-view-model.model';
import type { WalletFilterParams } from '@olv/ui-shared/models/wallet.model';

export interface WalletListNavState {
  activeTab: 'pooled' | 'dedicated' | 'one-time' | 'api';
  filterMap: Partial<WalletFilterParams>;
  filtersApplied: boolean;
  searchText: string;
}

export interface WalletNavigationState {
  wallet: WalletViewModel | OneTimeWalletViewModel;
  type: 'merchant' | 'system';
  returnUrl: string;
  walletType: string;
  listState?: WalletListNavState;
}
